import React, { forwardRef, useImperativeHandle, useState } from "react";
import { Button, Form } from "react-bootstrap";

import "./Resource.scss";

const validateResource = ({ name, link }) => {
  const urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
      "(\\#[-a-z\\d_]*)?$", // fragment locator
    "i",
  );

  if (name?.length <= 0) return false;
  if (link?.length <= 0 || !urlPattern.test(link)) return false;

  return true;
};

export const CreateResource = forwardRef(({ onCancel, onSubmit, mode = "create" }, ref) => {
  const [name, setName] = useState("");
  const [link, setLink] = useState("");

  useImperativeHandle(
    ref,
    () => ({
      setResource({ name, link }) {
        setName(name);
        setLink(link);
      },
    }),
    [],
  );

  return (
    <div className="resource resource-create d-flex align-items-center justify-content-between rounded-10 p-4">
      <div className="flex-grow-1 d-flex align-items-center me-4">
        <div className="icon d-flex align-items-center me-3">
          <i className="fa-solid fa-link fa-2x text-black-25" />
        </div>
        <div className="flex-grow-1 d-flex flex-column text-black-50">
          <Form.Control
            type="text"
            placeholder="Thêm tài nguyên"
            className="fw-bold border-0 outline-0 p-0 rounded-0 bg-transparent"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Form.Control
            type="text"
            placeholder="Điền đường link của tài nguyên"
            className="w-100 fs-7 border-0 outline-0 p-0 rounded-0 bg-transparent"
            value={link}
            onChange={(e) => setLink(e.target.value)}
          />
        </div>
      </div>

      {validateResource({ name, link }) && (
        <div className="d-flex flex-row">
          {onCancel && (
            <Button
              variant="outline"
              className="rounded-pill text-black-50 me-2 px-4 py-2"
              onClick={onCancel}
            >
              Huỷ
            </Button>
          )}
          <Button
            className="fw-bold bg-gradient-orange border-0 rounded-pill px-4 py-2"
            onClick={() => onSubmit({ name, link })}
          >
            {mode === "edit" ? "Sửa" : "Thêm"}
          </Button>
        </div>
      )}
    </div>
  );
});
